import { render, staticRenderFns } from "./AuthorityChange.vue?vue&type=template&id=1d6e99a2&scoped=true&"
import script from "./AuthorityChange.vue?vue&type=script&lang=js&"
export * from "./AuthorityChange.vue?vue&type=script&lang=js&"
import style0 from "./AuthorityChange.vue?vue&type=style&index=0&id=1d6e99a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6e99a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
